import { createFeatureSelector, createSelector } from "@ngrx/store";
import { UserSimple, UserState } from "../../models/user.model";

export const selectUserState = createFeatureSelector<UserState>('user_redux');

export const getUser = (user_id:string) => createSelector(selectUserState, userState => {
  return userState.entities[user_id] as UserSimple;
})
